import { frontendURL } from '../../../helper/URLHelper';
import SupportView from './components/SupportView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/support'),
    name: 'support_view',
    component: SupportView,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
